import camelcaseKeys from 'camelcase-keys'
import snakecaseKeys from 'snakecase-keys'

const camelcaseFields = response => camelcaseKeys(response, { deep: true })

export const snakecaseFields = response => snakecaseKeys(response)

export default camelcaseFields
